exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-editor-jsx": () => import("./../../../src/pages/editor.jsx" /* webpackChunkName: "component---src-pages-editor-jsx" */),
  "component---src-templates-storyblok-page-jsx": () => import("./../../../src/templates/storyblokPage.jsx" /* webpackChunkName: "component---src-templates-storyblok-page-jsx" */)
}

